module.exports = __webpack_public_path__ + "static/media/collaborative-document.ce8a0d14.svg";